import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TimePicker } from 'antd';
import moment from 'moment';
import Select from 'react-select';
import { Badge, Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';

import TickIcon from '../../../../../../../assets/images/tick.png';
import UntickIcon from '../../../../../../../assets/images/untick.png';
import { CONFIRM_BOOKING_BY_VENDOR, CONFIRM_BOOKING_BY_VENDOR_EMPTY, GET_REASON_BY_ACTIONS } from '../../../../../../../store/actions';

const ConfirmBooking = ({ currentSelectedBooking, onClose, bookingDetails }) => {
  const dispatch = useDispatch();

  const customer = {
    name: bookingDetails?.bookingDetails?.customer_name ?? '',
    players: bookingDetails?.bookingDetails?.number_of_players ?? '',
    guests: bookingDetails?.bookingDetails?.number_of_guests ?? '',
    nationality: bookingDetails?.bookingDetails?.nationality ?? '',
    addOns: bookingDetails?.bookingDetails?.add_ons?.split(',') ?? [],
  };

  const [selectedSlot, setSelectedSlot] = useState([]);
  const [slots, setSlots] = useState([]);
  const [confirmationNumber, setConfirmationNumber] = useState('');
  const [selectedRemark, setSelectedRemark] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [selectedSpecificSlotTime, setSelectedSpecificSlotTime] = useState(null);

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { confirmByVendor, confirmByVendorloading, remarksList } = useSelector(state => ({
    confirmByVendor: state?.ConfirmBookingByVendor?.data,
    confirmByVendorloading: state?.ConfirmBookingByVendor?.loading,

    remarksList: state?.GetReasonByActions?.data,
  }));

  useEffect(() => {
    let tempSlots = [];
    if (bookingDetails?.bookingDetails?.prefferedDateTime1 !== 'NA' && bookingDetails?.bookingDetails?.prefferedDateTime2 !== 'NA') {
      tempSlots = [
        { id: 'slot1', label: 'Preferred Slot 1', time: bookingDetails?.bookingDetails?.prefferedDateTime1 },
        { id: 'slot2', label: 'Preferred Slot 2', time: bookingDetails?.bookingDetails?.prefferedDateTime2 },
      ];
    } else if (bookingDetails?.bookingDetails?.prefferedDateTime1 !== 'NA') {
      tempSlots = [{ id: 'slot1', label: 'Preferred Slot 1', time: bookingDetails?.bookingDetails?.prefferedDateTime1 }];
    } else if (bookingDetails?.bookingDetails?.prefferedDateTime2 !== 'NA') {
      tempSlots = [{ id: 'slot2', label: 'Preferred Slot 2', time: bookingDetails?.bookingDetails?.prefferedDateTime2 }];
    }

    setSlots(tempSlots);
  }, [bookingDetails]);

  useEffect(() => {
    if (slots?.length > 0) {
      setSelectedSlot(slots[0] ?? []);
    }
  }, [slots]);

  useEffect(() => {
    dispatch({
      type: GET_REASON_BY_ACTIONS,
      payload: {
        urlParams: {
          booking_type: currentSelectedBooking?.bookingType,
          booking_status: currentSelectedBooking?.bookingStatus,
          action: 'confirm_booking',
          is_active: true,
          page_size: 50,
          page_index: 0,
        },
      },
    });
  }, [currentSelectedBooking]);

  useEffect(() => {
    if (confirmByVendor !== null) {
      dispatch({
        type: CONFIRM_BOOKING_BY_VENDOR_EMPTY,
      });
      onClose();
    }

    return () => {
      dispatch({
        type: CONFIRM_BOOKING_BY_VENDOR_EMPTY,
      });
    };
  }, [confirmByVendor]);

  const handleSubmit = () => {
    // onConfirm({ slotId: selectedSlot, remarks, confirmationNumber });
    const [date, time, day] = selectedSlot?.time?.split(' ') ?? [];
    setFormSubmitted(true);

    if (selectedRemark) {
      const confirmBookingPayload = {
        booking_id: currentSelectedBooking?.id,
        preffered_slot_date: moment(date, 'DD/MM/YYYY')?.format('YYYY-MM-DD'),
        preffered_slot_time: moment(`${time} ${day}`, 'h:mm A').format('HH:mm'),
        confirmation_number: confirmationNumber,
        reason_id: selectedRemark?.value,
        slot_time: selectedSpecificSlotTime ? selectedSpecificSlotTime.format('HH:mm') : null,
      };

      dispatch({
        type: CONFIRM_BOOKING_BY_VENDOR,
        payload: {
          body: {
            ...confirmBookingPayload,
          },
        },
      });
    }
  };

  console.log('slots data specific', selectedSpecificSlotTime, selectedSpecificSlotTime ? selectedSpecificSlotTime.format('HH:mm') : null);

  const { disabledHours, disabledMinutes } = useMemo(() => {
    if (!selectedSlot) {
      return { disabledHours: () => [], disabledMinutes: () => [] };
    }

    if (selectedSlot.id === 'slot1') {
      return getDisabledTimeRange(
        bookingDetails?.bookingDetails?.prefferedDateTime1ConfirmedTimeFrom,
        bookingDetails?.bookingDetails?.prefferedDateTime1ConfirmedTimeTo,
      );
    }

    if (selectedSlot.id === 'slot2') {
      return getDisabledTimeRange(
        bookingDetails?.bookingDetails?.prefferedDateTime2ConfirmedTimeFrom,
        bookingDetails?.bookingDetails?.prefferedDateTime2ConfirmedTimeTo,
      );
    }

    return { disabledHours: () => [], disabledMinutes: () => [] };
  }, [selectedSlot, bookingDetails]);

  return (
    <Modal isOpen={true} size="md">
      <ModalHeader toggle={onClose}>Confirm</ModalHeader>
      <ModalBody>
        <p className="text-muted">Are you sure you want to confirm this booking</p>

        {/* Slot selection with custom tick/untick icons */}
        <FormGroup tag="fieldset" className="mb-4">
          {slots?.map(slot => {
            const isSelected = selectedSlot?.id === slot.id;
            return (
              <div
                key={slot.id}
                onClick={() => {
                  setSelectedSlot(slot);
                  setSelectedSpecificSlotTime(null);
                }}
                className={`d-flex align-items-center p-3 mb-2 rounded 
                  ${isSelected ? 'border border-success' : 'border border-light'}`}
                style={{ cursor: 'pointer', border: isSelected ? '1px solid #0AB39C' : '1px solid #ced4da' }}
              >
                {/* tick / untick icon */}
                <div style={{ width: 24, height: 24, marginRight: 12 }}>
                  {isSelected ? <img src={TickIcon} width={24} height={24} /> : <img src={UntickIcon} width={24} height={24} />}
                </div>

                {/* slot label */}
                <div className="flex-grow-1">
                  <span className="font-weight-bold">{slot.label}</span>
                </div>

                {/* slot time */}
                <div className="font-weight-bold text-right">{slot.time}</div>
              </div>
            );
          })}
        </FormGroup>

        <Row className="mb-4">
          <Col xs="12">
            <Label for="remarksSelect">
              <strong>Specific Time for Slot</strong>
            </Label>
          </Col>
          <Col xs="12">
            <TimePicker
              className="w-100"
              use12Hours
              format="h:mm a"
              disabledHours={disabledHours}
              disabledMinutes={disabledMinutes}
              value={selectedSpecificSlotTime}
              onChange={time => {
                console.log('selected time:', time ? time.format('HH:mm') : null);

                setSelectedSpecificSlotTime(time);
              }}
            />
          </Col>
        </Row>

        {/* Customer details */}
        <Row className="mb-4">
          <Col xs="6">
            <strong>Customer name</strong>
          </Col>
          <Col xs="6" className="text-right">
            {customer?.name}
          </Col>
          <Col xs="6">
            <strong>No. of Players</strong>
          </Col>
          <Col xs="6" className="text-right">
            {customer?.players}
          </Col>

          <Col xs="6">
            <strong>No. of Guests</strong>
          </Col>
          <Col xs="6" className="text-right">
            {customer?.guests}
          </Col>

          {/* <Col xs="6">
            <strong>Nationality</strong>
          </Col>
          <Col xs="6" className="text-right">
            {customer.nationality}
          </Col> */}
          <Col xs="6">
            <strong>Add-ons</strong>
          </Col>
          <Col xs="6" className="text-right">
            {customer.addOns.map((a, index) => (
              <Badge pill className="addon-badge mr-2 border" key={index}>
                {a}
              </Badge>
            ))}
          </Col>
        </Row>

        {/* Remarks dropdown */}
        <FormGroup>
          <Label for="remarksSelect">
            <strong>
              Remarks <span className="lbl_mandatory"> *</span>
            </strong>
          </Label>
          <Select
            id="confirm-remarks"
            name="confirm-remarks"
            placeholder="Select reason for Modify the booking"
            value={selectedRemark}
            options={remarksList?.reasons?.map((remark, index) => ({
              label: `${remark?.reason}`,
              value: `${remark?.id}`,
            }))}
            onChange={data => {
              setSelectedRemark(data);
            }}
          />
          {formSubmitted && selectedRemark === null && <div className="text-danger">Remarks are required</div>}
        </FormGroup>

        {/* Confirmation Number */}
        <FormGroup>
          <Label for="confirmationNumber">
            <strong>Confirmation Number</strong>
          </Label>
          <Input
            type="text"
            id="confirmationNumber"
            value={confirmationNumber}
            onChange={e => {
              const input = e.target.value;
              setConfirmationNumber(input); // no formatting or restriction
            }}
            placeholder="Enter confirmation number"
          />
        </FormGroup>
      </ModalBody>

      <div className="d-flex justify-content-center mb-4 gap-3">
        {!confirmByVendorloading && (
          <Button color="primary" style={{ fontSize: '18px', width: '217px', borderRadius: '10px' }} onClick={handleSubmit}>
            Yes
          </Button>
        )}

        {confirmByVendorloading && (
          <Button color="primary" style={{ fontSize: '18px', width: '217px', borderRadius: '10px' }}>
            <Spinner className="btn-replacer-spinner" />
          </Button>
        )}

        <Button color="white" style={{ fontSize: '18px', width: '217px', borderRadius: '10px', border: '1px solid #401589' }} onClick={onClose}>
          No
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmBooking;

function getDisabledTimeRange(startTime, endTime) {
  if (!startTime || !endTime) {
    // no restrictions → allow everything
    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
    };
  }

  const start = moment(startTime, 'HH:mm');
  const end = moment(endTime, 'HH:mm');

  const startHour = start.hour();
  const startMinute = start.minute();
  const endHour = end.hour();
  const endMinute = end.minute();

  const disabledHours = () => {
    const disabled = [];
    for (let i = 0; i < 24; i++) {
      if (i < startHour || i > endHour) {
        disabled.push(i);
      }
    }
    return disabled;
  };

  const disabledMinutes = selectedHour => {
    let minutes = [];
    if (selectedHour === startHour) {
      // disable before startMinute
      minutes = minutes.concat(Array.from({ length: startMinute }, (_, i) => i));
    }
    if (selectedHour === endHour) {
      // disable after endMinute
      minutes = minutes.concat(Array.from({ length: 59 - endMinute }, (_, i) => i + endMinute + 1));
    }
    return minutes;
  };

  return { disabledHours, disabledMinutes };
}
